import get from 'lodash/get'

export const isLoadingVisit = (state) => get(state, ['vegetation', 'visit', 'loading'])
export const isCopyingVisit = (state) => get(state, ['vegetation', 'visit', 'copyVisitLoading'])
export const getEditingVisit = (state) => get(state, ['vegetation', 'visit', 'editingVisit'])



// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/visit.js